import {
  AfterViewInit,
  Attribute,
  Component, ElementRef, HostBinding, Inject,
  Injector, OnInit,
  Optional, SkipSelf
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { APPLY_STYLES_TYPE,DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, register, styler } from "@wm/components-base";
import {get, noop} from "lodash-es";
import { TabsComponent } from '../tabs.component';
import { runtimeEventManager,isDefined ,removeAttr, toBoolean} from "@wm/core";
import {WmsTranscludeDirective} from "../../../page/wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'tab-pane';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-tabpane',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmTabPane]',
  template: `<div class="tab-body" page-container-target partial-container-target wmsTransclude><ng-content></ng-content></div>`,
  providers: [
    provideAsWidgetRef(TabPaneComponent)
  ],
  exportAs: 'wmTabPane',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class TabPaneComponent extends StylableComponent implements AfterViewInit, OnInit {
  static initializeProps = register('wm-tabpane');
  private _isFirstLoad: boolean = true;
  public name: string;
  public show: boolean;
  public smoothscroll: any;
  private isdynamic: boolean;
  paneicon:string;
  tabindex:number;
  badgetype:any;
  badgevalue:any;
  tabIndex:any
  element:any
  parentScope:any

  $lazyLoad: Function = noop;


  @HostBinding('class.active') isActive = false;
  @HostBinding('class.disabled') disabled = false;


  constructor(inj: Injector,
              @Attribute('heading') public heading:string,
              @Attribute('title') public title:string,
              @SkipSelf() @Optional() private _viewParent: TabsComponent,
              @SkipSelf() @Inject(ElementRef) public _el: any){
    super(inj, WIDGET_CONFIG, _viewParent);
    removeAttr(this.nativeElement, 'title');

  }

  override ngAfterViewInit() {
    styler(
      this.nativeElement.querySelector('.tab-body') as HTMLElement,
      this,
      APPLY_STYLES_TYPE.CONTAINER
    );
    this.parentScope.registerHeader(this)
  }

  public deselect() {
    if (this.isActive) {
      this.isActive = false;
    }
  }

  public select($event?: Event, pane?: any) {
    // When called programatically $event won't be available
    if ((this.isActive && this.nativeElement.classList.contains('canvas-active-widget'))) {
      return;
    }
    this.notifyParent($event);
    this.isActive = true;
    if (this.isActive) {
      setTimeout(() => this.$lazyLoad(), 100);
    }

    if (isDefined(pane) && isDefined($event)) {
      $event?.stopPropagation();
      runtimeEventManager.emit('selectTabPane', {widgetId: pane.widgetId});
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.title || this.heading;
    this.show = this.show || toBoolean(this.$attrs.get('show.bind'));
    this.getParentScope().tabs.push(this);
  }

  private getParentScope(): TabsComponent {
    this.parentScope = this._viewParent || this._el.nativeElement.widget || get($(this.nativeElement).closest('[widgettype="wm-tabs"]')[0], 'widget');
    return this.parentScope;
  }


  private notifyParent(evt?: Event) {
    this.getParentScope()?.notifyChange(this, evt);
  }

  onRemove() {
    this.parentScope.onTabPaneDestroyed(this);

  }

  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'content') {
      if (this.isActive) {
        setTimeout(() => this.$lazyLoad(), 100);
      }
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }
}

